function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomBalconyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3c-.55 0-1 .45-1 1v12h2V5h4.03c0 1.01-.1 2.27-.39 3.43-.4 1.61-1.09 2.74-2.04 3.15-.28.12-.49.36-.57.66-.08.3-.02.61.17.86.22.29.56.81.84 1.39.29.6.46 1.15.46 1.51h2c0-.83-.33-1.71-.66-2.39-.14-.28-.29-.56-.43-.8 1.19-.96 1.83-2.49 2.18-3.89.34-1.35.45-2.77.45-3.92h5.93c0 1.15.11 2.57.45 3.92.35 1.4.99 2.93 2.18 3.89-.15.25-.3.52-.43.8-.33.68-.66 1.55-.66 2.39h2c0-.37.17-.91.46-1.51.28-.58.62-1.1.84-1.39.18-.25.25-.56.17-.86a.993.993 0 00-.57-.66c-.95-.41-1.63-1.54-2.04-3.15-.29-1.16-.39-2.42-.39-3.43h4.03v11h2V4c0-.55-.45-1-1-1H6zM2 20h1v8H2v2h28v-2h-1v-8h1v-2H2v2zm25 0v8h-4v-8h4zm-6 0h-4v8h4v-8zm-6 0v8h-4v-8h4zm-6 0H5v8h4v-8z",
    fill: props.color
  }));
}

export default SvgIconRoomBalconyFilled;